import React, { useEffect, useState } from "react";
import "../css/UserPannel.css";
import { BASE_URL } from "../config";
import { getAuthHeaders } from "../services/useAuth";
import CustomButton from "./CustomButton";
import { fetchRoles, updateEmployeeRole } from "../services/stockistService";
import Loader from "../dist/Loader";

const EmployeeDetails = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [employees, setEmployees] = useState([]);
  const [loadRoles, setLoadRoles] = useState([]);
  const [editingEmployeeId, setEditingEmployeeId] = useState(null);
  const [selectedRoles, setSelectedRoles] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`, {
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));
  }, []);

  const fetchEmployees = async (stateId) => {
    setIsLoading(true);

    try {
      const res = await fetch(`${BASE_URL}/api/employees?state_id=${stateId}`, {
        headers: getAuthHeaders(),
      });

      const data = await res.json();

      setEmployees(data);

      const rolesMap = {};
      data.forEach((emp) => {
        rolesMap[emp.id] = emp.user_role || "";
      });

      setSelectedRoles(rolesMap);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedState(stateId);
  };

  const handleGoClick = () => {
    if (selectedState) {
      fetchEmployees(selectedState);
    } else {
      alert("Please select a state first");
    }
  };

  const handleSend = (emp) => {
    console.log("Employee object:", emp);

    const payload = {
      id: emp.id,
      first_name: emp.first_name,
      last_name: emp.last_name,
      username: emp.employee,
      password_hash: emp.password,
      mobile: `+91${emp.mobile}`,
    };

    console.log("Sending payload:", payload);

    fetch(`${BASE_URL}/api/send_message`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (res.ok) {
          alert(`Message sent to ${emp.first_name} ${emp.last_name}`);
        } else {
          res.json().then((err) => {
            console.error("Server error response:", err);
            alert(`Failed to send message: ${err.detail || "Unknown error"}`);
          });
        }
      })
      .catch((err) => {
        console.error("Network or fetch error:", err);
        alert(`Error sending message`);
      });
  };

  const handleResetPassword = (emp) => {
    if (
      !window.confirm(`Reset password for ${emp.first_name} ${emp.last_name}?`)
    )
      return;

    fetch(`${BASE_URL}/api/reset_password/${emp.id}`, {
      method: "PUT",
      headers: getAuthHeaders(),
    })
      .then((res) => res.json())
      .then((data) => {
        alert(`Password reset! New password: ${data.new_password}`);
        setEmployees((prev) =>
          prev.map((e) =>
            e.id === emp.id ? { ...e, password: data.new_password } : e,
          ),
        );
      })
      .catch((err) => {
        console.error("Reset failed:", err);
        alert("Failed to reset password.");
      });
  };

  const handleEditClick = (empId) => {
    setEditingEmployeeId(empId);
  };

  const handleCancelClick = () => {
    setEditingEmployeeId(null);
    const rolesMap = {};
    employees.forEach((emp) => {
      rolesMap[emp.id] = emp.user_role || "";
    });
    setSelectedRoles(rolesMap);
  };

  const handleRoleChange = (empId, newRole) => {
    setSelectedRoles((prev) => ({
      ...prev,
      [empId]: newRole,
    }));
  };

  const handleUpdateRole = async (emp) => {
    const newRole = selectedRoles[emp.id];
    if (!newRole) {
      alert("Please select a role");
      return;
    }
    try {
      await updateEmployeeRole(emp.id, newRole);
      alert(`Role updated successfully for ${emp.first_name} ${emp.last_name}`);

      setEmployees((prev) =>
        prev.map((e) => (e.id === emp.id ? { ...e, user_role: newRole } : e)),
      );
      setEditingEmployeeId(null);
    } catch (error) {
      console.error("Error updating role:", error);
      alert("Failed to update role");
    }
  };

  useEffect(() => {
    const loadRolesData = async () => {
      try {
        const rolesData = await fetchRoles();
        setLoadRoles(rolesData);
      } catch (error) {
        console.error("Error loading roles:", error);
      }
    };
    loadRolesData();
  }, []);

  return (
    <div className="p-2  border-2 border-gray-300 rounded-lg bg-white">
      {isLoading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/25">
          <Loader onCancel={() => setIsLoading(false)} />
        </div>
      )}
      <div className="p-4 border-2 border-gray-300 rounded-lg bg-gray-50">
        <h1 className="text-xl sm:text-2xl font-bold text-center text-gray-800 mb-4">
          <span className="text-blue-700">Employee </span>
          <span className="text-blue-500">Password</span>
        </h1>

        <div className="employee-filter-container">
          <label htmlFor="stateSelect">State</label>
          <select
            id="stateSelect"
            className="employee-state-dropdown"
            value={selectedState}
            onChange={handleStateChange}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
          <CustomButton
            label={isLoading ? "Loading..." : "GO"}
            onClick={handleGoClick}
            variant="go"
            className="font-bold"
            disabled={isLoading}
          />
        </div>

        <div className="border rounded shadow  table-wrapper">
          <table className="unlock-dcr-leave-table text-sm ">
            <thead className="bg-blue-500 text-white">
              <tr>
                <th>S.No</th>
                <th>User Name</th>
                <th className="text-left">Employee</th>
                <th>State</th>
                <th>HQ</th>
                <th>Mobile</th>
                <th>Designation</th>
                <th>Can Login</th>
                <th>Role</th>
                <th>Password</th>
                <th>Action</th>
                <th>Role update</th>
                <th>
                  Password
                  <br />
                  Reset
                </th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr key={emp.id} className="text-center">
                  <td>{index + 1}</td>
                  <td className="whitespace-nowrap">{emp.employee}</td>
                  <td className="text-left whitespace-nowrap">
                    {emp.first_name} {emp.last_name}
                  </td>
                  <td>{emp.state_name}</td>
                  <td>{emp.headquarter_name}</td>
                  <td>{emp.mobile}</td>
                  <td>{emp.designation}</td>

                  <td>
                    <input
                      type="checkbox"
                      checked={emp.status === "WORKING"}
                      readOnly
                    />
                  </td>

                  {/* ROLE SELECT */}
                  <td className="whitespace-nowrap">
                    {editingEmployeeId === emp.id ? (
                      <select
                        value={selectedRoles[emp.id] || ""}
                        onChange={(e) =>
                          handleRoleChange(emp.id, e.target.value)
                        }
                        className="border border-gray-300 rounded p-1 text-xs w-[100px]"
                      >
                        <option value="">Select Role</option>
                        {loadRoles.map((role, idx) => (
                          <option key={idx} value={role}>
                            {role}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <span>{emp.user_role || "MR"}</span>
                    )}
                  </td>

                  <td>{emp.password}</td>

                  {/* SEND BUTTON */}
                  <td>
                    <CustomButton
                      onClick={() => handleSend(emp)}
                      className="bg-slate-500 text-white w-[90px] py-1 text-[11px] rounded"
                    >
                      Send
                    </CustomButton>
                  </td>

                  {/* ROLE UPDATE / EDIT */}
                  <td>
                    {editingEmployeeId === emp.id ? (
                      <div className="flex justify-center gap-1">
                        <CustomButton
                          onClick={() => handleUpdateRole(emp)}
                          className="bg-blue-500 text-white w-[100px] py-1 text-[11px] rounded"
                        >
                          Update
                        </CustomButton>

                        <CustomButton
                          onClick={handleCancelClick}
                          className="bg-gray-500 text-white w-[90px] py-1 text-[11px] rounded"
                        >
                          Cancel
                        </CustomButton>
                      </div>
                    ) : (
                      <CustomButton
                        onClick={() => handleEditClick(emp.id)}
                        className="bg-amber-500 text-white w-[90px] py-1 text-[11px] rounded"
                      >
                        Edit
                      </CustomButton>
                    )}
                  </td>

                  {/* RESET PASSWORD */}
                  <td>
                    <CustomButton
                      onClick={() => handleResetPassword(emp)}
                      className="bg-red-500 text-white w-[150px] py-1 text-[11px] rounded whitespace-nowrap"
                    >
                      Reset Pass
                    </CustomButton>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
